// extracted by mini-css-extract-plugin
module.exports = {"nav":"AboutHeader_nav__3byin","signinbtn":"AboutHeader_signinbtn__258_m"};